export default class RolloutStatusCounts {

    public pending: number = 0;
    public inProgress: number = 0;
    public success: number = 0;
    public error: number = 0;
    public cancelled: number = 0;
    public total: number = 0;

    constructor(data: { [key: string]: any }) {
        this.pending = data['pending'] ?? 0;
        this.inProgress = data['inProgress'] ?? 0;
        this.success = data['success'] ?? 0;
        this.error = data['error'] ?? 0;
        this.cancelled = data['cancelled'] ?? 0;
        this.total = data['total'] ?? 0;
    }
}
